import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import HotspotImage from './HotspotImage';
import Image from '../components/Image';

const styles = theme => ({
    root: {
        position: 'relative',
    },
    controls: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.grey[400]}`
    },
    guaranteeImage: {
        position: 'absolute',
        right: '-2%',
        top: '-2%',
        width: '12%',
        zIndex: 1,
    }
});

  
class HotspotRotator extends React.Component {
    state = {
        index: 0,
    }

    handleHotspotChange = (increment) => e => {
        this.setState((state, props) => {
            const newIndex = state.index + increment;
            return {index: newIndex >= props.images.length ? 0 : (newIndex < 0 ? props.images.length - 1 : newIndex)};
        });
    }

    render() {
        const { classes, images } = this.props;
    
        return (
            <div className={classes.root}>
                <Image className={classes.guaranteeImage} src="/homepage/directbuy-risk-free-guarantee-badge.png" />
                {images.map((props, i) => <Fade key={i} timeout={{enter: 800, exit: 0}} in={this.state.index === i}><HotspotImage show={this.state.index === i} {...props}/></Fade>)}
                <div className={classes.controls}>
                    <IconButton onClick={this.handleHotspotChange(-1)}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <IconButton onClick={this.handleHotspotChange(1)}>
                        <ChevronRightIcon />
                    </IconButton>
                </div>
            </div>
        );
    }
}

HotspotRotator.propTypes = {
    classes: PropTypes.object.isRequired,
    images: PropTypes.array.isRequired
};

export default withStyles(styles)(HotspotRotator);
